<h2 mat-dialog-title>{{ 'INBOX.WEBCHAT.SETTINGS.ENABLE_LEAD_CAPTURE.DESCRIPTION' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'INBOX.WEBCHAT.SETTINGS.ENABLE_LEAD_CAPTURE_DIALOG.INFORMATION' | translate }}</p>
  <p>{{ 'INBOX.WEBCHAT.SETTINGS.ENABLE_LEAD_CAPTURE_DIALOG.INFORMATION_2' | translate }}</p>
  <p>{{ 'INBOX.WEBCHAT.SETTINGS.ENABLE_LEAD_CAPTURE_DIALOG.INFORMATION_3' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" mat-dialog-close>{{ 'INBOX.CLOSE' | translate }}</button>
</mat-dialog-actions>
